module.exports = __webpack_public_path__ + "img/package_premier.3ed77e50.jpg";